module.exports = {
      id: "d836cc11d409ed19d1035d401d7732bbstate-good.svg-usage",
      viewBox: "0 0 200 200",
      url: __webpack_public_path__ + "sprite.svg#d836cc11d409ed19d1035d401d7732bbstate-good.svg",
      toString: function () {
        return this.url;
      }
    }